import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../translations';
import Button from '../Button/Button';
import { getCurrentBranch } from '../../selectors/pageFooter/pageFooter';
import { getPageFooterInfoAction } from '../../actions/actionCreators';
import { Paragraph } from '../../theme/styles';
import './PageFooter.css';

const FooterLink = ({ linkName, link, text }) => (
    <a id={`${linkName}Link`} href={link} className="pageFooterContent hyperlink-label">
        {text}
    </a>
);

const PrivactPolicyModal = ({ onPrivacyPolicySeenbuttonClick }) => (
    <div id="privacyPolicyModal">
        <div id="privacyPolicyText" style={Paragraph}>
            {translate('by_navigating_on_this_site_you_agree_and_consent_to_our_user')}
            <a href="https://www.movista.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                {translate('privacy_policy')}
            </a>
            <Button id="privacyPolicyButton" onClick={onPrivacyPolicySeenbuttonClick} content={translate('i_accept')} />
        </div>
    </div>
);

export const PageFooter = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getPageFooterInfoAction());
    }, [dispatch]);
    const privacyPolicySeen = localStorage.getItem('privacyPolicySeen');
    const currentYear = new Date().getFullYear();
    const [privacyPolicyModalActive, setprivacyPolicyModalActive] = useState(!privacyPolicySeen);
    const currentBranch = useSelector(getCurrentBranch);
    const onPrivacyPolicySeenbuttonClick = () => {
        localStorage.setItem('privacyPolicySeen', 1);
        setprivacyPolicyModalActive(false);
    };

    return (
        <>
            { privacyPolicyModalActive && (<PrivactPolicyModal onPrivacyPolicySeenbuttonClick={onPrivacyPolicySeenbuttonClick} />)}
            <footer id="footerWrap" style={Paragraph}>
                <div id="footerContent">
                    <div className="primary">
                        <nav className="links">
                            <FooterLink
                                linkName="tos"
                                link="https://www.movista.com/terms-of-use/"
                                text={translate('terms_of_use')}
                                target="_blank"
                                rel="noopener noreferrer"
                            />
                            <FooterLink
                                linkName="privacyPolicy"
                                link="https://www.movista.com/privacy-policy/"
                                text={translate('privacy_policy')}
                                target="_blank"
                                rel="noopener noreferrer"
                            />
                            <FooterLink
                                linkName="registerWithMovista"
                                link="/rep/apply"
                                text={translate('register_with_movista')}
                            />
                        </nav>
                        <div className="copyright">
                            {`${translate('copyright')}© ${currentYear} ${translate('movista_inc_all_rights_reserved')}`}
                        </div>
                    </div>
                    {
                        currentBranch && (
                            <div className="secondary">
                                <span className="branch">
                                    {`${translate('current_branch')}: ${currentBranch}`}
                                </span>
                                <span className="environment" title="React PageFooter">
                                    &#128062;
                                </span>
                            </div>
                        )
                    }
                </div>
            </footer>
        </>
    );
};

export default PageFooter;
